/**
 * FilterChipRow: the status filter of an /admin table (All / Active /
 * Pending / Inactive), drawn as Carbon contained tabs with count tags
 * (mockup 02's status tabs). The tabs sit in the DataTable's `tabs` slot,
 * between its head and its toolbar.
 *
 * The optional search renders as the Carbon toolbar search under the tabs
 * when `onSearchChange` is supplied.
 */
import { ContainedTabs } from '@/components/carbon/ContainedTabs'
import { TableSearch } from '@/components/carbon/TableSearch'

export interface FilterChip {
  key: string
  label: string
  count?: number
}

export interface FilterChipRowProps {
  chips: FilterChip[]
  active: string
  onChange(key: string): void
  searchValue?: string
  onSearchChange?(value: string): void
  searchPlaceholder?: string
  /** The tab list's accessible name. Default "Filter by status". */
  ariaLabel?: string
}

export default function FilterChipRow({
  chips,
  active,
  onChange,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search',
  ariaLabel = 'Filter by status',
}: FilterChipRowProps) {
  return (
    <>
      <ContainedTabs
        aria-label={ariaLabel}
        value={active}
        onChange={onChange}
        tabs={chips.map((chip) => ({ id: chip.key, label: chip.label, count: chip.count }))}
      />
      {onSearchChange ? (
        <div className="flex min-w-0 bg-layer-1">
          <TableSearch value={searchValue ?? ''} onChange={onSearchChange} label={searchPlaceholder} />
        </div>
      ) : null}
    </>
  )
}
